module.exports = __webpack_public_path__ + "static/media/Tentacle_Resist_Ending.3325ce86.mp3";